import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { call } from "@redux-saga/core/effects";
import { queryClient } from "../../../store";
import { UserNotificationsDataTypes } from "../../../../Schema/notification.types";
import { alert } from "../../../../Utils/toast";
import i18next from "../../../../i18next";

export type GetAnnouncedNotificationsLoadAction = {
  type: string;
  payload: {};
};

export type GetAnnouncedNotificationsData = {
  data: UserNotificationsDataTypes;
};

const GetAnnouncedNotifications = new ReduxFetchState<
  GetAnnouncedNotificationsData | null,
  {},
  any
>("getAnnouncedNotifications");

export function* watchGetAnnouncedNotifications(action: GetAnnouncedNotificationsLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetAnnouncedNotificationsData = yield call([queryClient, queryClient.fetchQuery], {
      queryKey: ["getAnnouncedNotifications", lang],
      queryFn: async () => {
        try {
          const res = await axios({
            url: "/api/v1/users/notifications/announced/overview",
            method: "GET",
            headers: { lang },
          });
          return { data: res.data };
        } catch (err: any) {
          alert({
            //@ts-ignore
            message: err?.response?.data?.error ?? i18next.t("somethingWentWrong"),
            type: "error",
          });
        }
      },
      staleTime: 5 * 60 * 1000,
    });

    yield put(GetAnnouncedNotifications.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    yield put(GetAnnouncedNotifications.actions.loadFailure(e?.response?.data));
  }
}

export function* getAnnouncedNotificationsSagas() {
  yield takeEvery(GetAnnouncedNotifications.actionTypes.load, watchGetAnnouncedNotifications);
}

export function useGetAnnouncedNotifications() {
  const { loading, data, ...getAnnouncedNotificationsState } = useAppSelector(
    (state) => state.getAnnouncedNotifications,
  );
  const dispatch = useAppDispatch();

  const dispatchGetAnnouncedNotifications = useCallback(() => {
    dispatch(GetAnnouncedNotifications.actions.load());
  }, [dispatch]);

  return {
    ...getAnnouncedNotificationsState,
    dispatchGetAnnouncedNotifications,
    getAnnouncedNotificationsLoading: loading,
    getAnnouncedNotificationsData: data,
  };
}

export const {
  actionTypes: getAnnouncedNotificationsActionsTypes,
  actions: getAnnouncedNotificationsActions,
  reducer: getAnnouncedNotificationsReducer,
} = GetAnnouncedNotifications;
